import React, { useState } from "react";
import {
  ChevronRight,
  ChevronLeft,
  Store,
  User,
  MapPin,
  FileText,
  Upload,
  CheckCircle,
} from "lucide-react";

import Swal from "sweetalert2";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import Breadcrumb from "../../components/Breadcrumb";
import BottomFooter from "../../components/BottomFooter";
import HeaderOne from "../../components/HeaderOne";
import FooterOne from "../../components/FooterOne";

const SellerForm = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [step, setStep] = useState(1);
  const [isReview, setIsReview] = useState(false);
  const [agree, setAgree] = useState(false);
  const totalSteps = 5;

  const [errors, setErrors] = useState({});

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    timer: 1600,
    showConfirmButton: false,
  });

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    dob: "",
    businessName: "",
    businessType: "",
    gstNumber: "",
    businessNumber: "",
    panNumber: "",
    shopAddress: "",
    city: "",
    state: "",
    pincode: "",
    accountHolder: "",
    accountNumber: "",
    ifsc: "",
    bankName: "",
    panCard: null,
    gstCertificate: null,
    addressProof: null,
    cancelledCheque: null,
    businessproof: null,
  });

  const [preview, setPreview] = useState({
    panCard: null,
    gstCertificate: null,
    addressProof: null,
    cancelledCheque: null,
    businessproof: null,
  });

  // Hostinger Upload Function
  // const uploadToHostinger = async (file) => {
  //   if (!file) return null;

  //   const form = new FormData();
  //   form.append("media[]", file);

  //   try {
  //     const res = await fetch(
  //       "https://orangered-rat-360569.hostingersite.com/api/addFiles",
  //       { method: "POST", body: form }
  //     );

  //     const data = await res.json();
  //     const fileName = data.urls[0];

  //     return `https://orangered-rat-360569.hostingersite.com/storage/app/public/files/${fileName}`;
  //   } catch (err) {
  //     Swal.fire("Error", "Failed to upload document", "error");
  //     return null;
  //   }
  // };
  const uploadToS3 = async (file) => {
    if (!file) return null;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/upload/single`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await res.json();
      return data.fileUrl; // <- S3 URL
    } catch (err) {
      Swal.fire("Error", "Failed to upload document", "error");
      return null;
    }
  };

  const REGEX = {
    phone: /^\+?[0-9]{10,13}$/,
    pincode: /^[0-9]{6}$/,
    gst: /.*/,
    pan: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
    account: /^[0-9]{9,18}$/,
    ifsc: /^[A-Z]{4}0[A-Z0-9]{6}$/,
  };

  const handleChange = (e) => {
    setErrors({});
    const { name, value } = e.target;

    let val = value;

    if (name === "fullName") {
      if (!/^[A-Za-z ]*$/.test(val)) return;
    }

    if (["panNumber", "gstNumber", "ifsc"].includes(name)) {
      val = val.toUpperCase().replace(/\s/g, "");
    }

    if (["pincode", "phone", "accountNumber"].includes(name)) {
      val = val.replace(/[^0-9+]/g, "");
    }

    setFormData({ ...formData, [name]: val });
  };

  // File Change with Preview
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    if (files && files[0]) {
      const file = files[0];

      setFormData((prev) => ({ ...prev, [name]: file }));

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview((prev) => ({ ...prev, [name]: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  // Step validation
  const validateStep = () => {
    let temp = {};

    if (step === 1) {
      if (!formData.fullName.trim()) temp.fullName = "Required";
      if (!formData.email.trim()) temp.email = "Required";
      if (!REGEX.phone.test(formData.phone)) temp.phone = "Invalid";
      if (!formData.dob.trim()) temp.dob = "Required";
    }

    if (step === 2) {
      if (!formData.businessName.trim()) temp.businessName = "Required";
      if (!formData.businessType.trim()) temp.businessType = "Required";
      if (!REGEX.pan.test(formData.panNumber)) temp.panNumber = "Invalid PAN";
      if (formData.gstNumber && !REGEX.gst.test(formData.gstNumber))
        temp.gstNumber = "Invalid";
    }

    if (step === 3) {
      if (!formData.shopAddress.trim()) temp.shopAddress = "Required";
      if (!formData.city.trim()) temp.city = "Required";
      if (!formData.state.trim()) temp.state = "Required";
      if (!REGEX.pincode.test(formData.pincode)) temp.pincode = "Invalid";
    }

    if (step === 4) {
      if (!formData.accountHolder.trim()) temp.accountHolder = "Required";
      if (!REGEX.account.test(formData.accountNumber))
        temp.accountNumber = "Invalid";
      if (!REGEX.ifsc.test(formData.ifsc)) temp.ifsc = "Invalid";
      if (!formData.bankName.trim()) temp.bankName = "Required";
    }

    setErrors(temp);

    if (Object.keys(temp).length > 0) {
      Toast.fire({ icon: "error", title: "Fix highlighted fields" });
      return false;
    }

    return true;
  };

  const nextStep = () => {
    if (step !== totalSteps && !validateStep()) return;

    if (isReview && !agree) {
      Swal.fire(
        "Required",
        "Please accept the policies to continue",
        "warning"
      );
      return;
    }

    if (step === totalSteps && !isReview) {
      setIsReview(true);
    } else if (isReview) {
      handleSubmit();
    } else {
      setStep(step + 1);
    }
  };

  const prevStep = () => {
    if (isReview) setIsReview(false);
    else setStep(step - 1);
  };

  // Final Submit — Hostienger Upload & URl
  // const handleSubmit = async () => {
  //   try {
  //     Swal.fire({ title: "Uploading...", allowOutsideClick: false });
  //     Swal.showLoading();

  //     const panURL = await uploadToHostinger(formData.panCard);
  //     const gstURL = await uploadToHostinger(formData.gstCertificate);
  //     const addURL = await uploadToHostinger(formData.addressProof);
  //     const chequeURL = await uploadToHostinger(formData.cancelledCheque);

  //     const payload = {
  //       ...formData,
  //       panCard: panURL,
  //       gstCertificate: gstURL,
  //       addressProof: addURL,
  //       cancelledCheque: chequeURL,
  //     };

  //     const res = await fetch(
  //       `${process.env.REACT_APP_API_URL}/seller/seller`,
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     const output = await res.json();

  //     if (res.ok) {
  //       Swal.fire("Success", "Your application was submitted!", "success");
  //       setIsSuccess(true);
  //     } else {
  //       Swal.fire("Error", output.message || "Something went wrong", "error");
  //     }
  //   } catch (err) {
  //     Swal.fire("Error", "Network issue!", "error");
  //   }
  // };

  const handleSubmit = async () => {
    try {
      Swal.fire({ title: "Uploading...", allowOutsideClick: false });
      Swal.showLoading();

      // Upload all documents to S3
      const panURL = await uploadToS3(formData.panCard);
      const gstURL = await uploadToS3(formData.gstCertificate);
      const addURL = await uploadToS3(formData.addressProof);
      const chequeURL = await uploadToS3(formData.cancelledCheque);
      const businessURL = await uploadToS3(formData.businessproof);

      const payload = {
        ...formData,
        panCard: panURL,
        gstCertificate: gstURL,
        addressProof: addURL,
        cancelledCheque: chequeURL,
        businessproof: businessURL,
      };

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/seller/seller`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const output = await res.json();

      if (res.ok) {
        Swal.fire("Success", "Your application was submitted!", "success");
        setIsSuccess(true);
      } else {
        Swal.fire("Error", output.message || "Something went wrong", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Network issue!", "error");
    }
  };

  const inputClass = "common-input w-full";
  const errorBorder = { border: "1px solid red", background: "#ffe5e5" };
  const highlight = (name) => (errors[name] ? errorBorder : {});
  const labelClass =
    "text-neutral-900 text-sm sm:text-lg mb-4 sm:mb-8 fw-medium block whitespace-normal";

  const StepIndicator = () => (
    <div className="flex flex-wrap sm:flex-nowrap items-center justify-center mb-8 gap-y-8">
      {["Personal", "Business", "Address", "Bank", "Documents"].map(
        (label, idx) => {
          const current = idx + 1;
          const isActive = current === step && !isReview;
          const isDone = current < step || (current === step && isReview);

          return (
            <div
              key={label}
              className="w-1/3 sm:flex-1 flex flex-col items-center mb-10 sm:mb-20"
            >
              <div
                className={`w-20 h-20 flex items-center justify-center rounded-full border ${
                  isActive
                    ? "border-main-600 bg-main-600 text-white"
                    : isDone
                    ? "border-success-500 bg-success-500 text-white"
                    : "border-gray-100 bg-white text-neutral-500"
                }`}
              >
                {isDone ? <CheckCircle size={20} /> : <span>{current}</span>}
              </div>
              <span className="text-xs mt-8 text-neutral-600 font-semibold">
                {label}
              </span>
            </div>
          );
        }
      )}
    </div>
  );

  //   const StepIndicator = () => (
  //   <div className="flex items-start justify-between mb-8 gap-1 sm:gap-4 overflow-x-auto px-2">
  //     {["Personal", "Business", "Address", "Bank", "Documents"].map(
  //       (label, idx) => {
  //         const current = idx + 1;
  //         const isActive = current === step && !isReview;
  //         const isDone = current < step || (current === step && isReview);

  //         return (
  //           <div key={label} className="flex flex-col items-center min-w-[60px] sm:min-w-0 sm:flex-1">
  //             <div
  //               className={`w-10 h-10 sm:w-16 sm:h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full border-2 ${
  //                 isActive
  //                   ? "border-main-600 bg-main-600 text-white"
  //                   : isDone
  //                   ? "border-success-500 bg-success-500 text-white"
  //                   : "border-gray-100 bg-white text-neutral-500"
  //               }`}
  //             >
  //               {isDone ? <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5" /> : <span className="text-xs sm:text-sm md:text-base">{current}</span>}
  //             </div>
  //             <span className="text-[10px] sm:text-xs mt-2 sm:mt-4 text-neutral-600 font-semibold text-center leading-tight">
  //               {label}
  //             </span>
  //           </div>
  //         );
  //       }
  //     )}
  //   </div>
  // );

  // Form rendering
  const renderStep = () => {
    if (step === 5 && isReview) {
      return (
        <>
          <div className="space-y-6">
            <div className="flex items-center gap-3 mb-4">
              <CheckCircle size={20} className="text-main-600" />
              <h2 className="text-xl fw-semibold">Review Your Information</h2>
            </div>
            <div className="space-y-6">
              {/* PERSONAL INFO */}
              <div className="p-4 bg-white rounded-xl shadow-sm border">
                <h4 className="font-semibold mb-3 text-main-600">
                  Personal Information
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                  <p>
                    <b>Name:</b> {formData.fullName}
                  </p>
                  <p>
                    <b>Email:</b> {formData.email}
                  </p>
                  <p>
                    <b>Phone:</b> {formData.phone}
                  </p>
                  <p>
                    <b>DOB:</b> {formData.dob}
                  </p>
                </div>
              </div>

              {/* BUSINESS INFO */}
              <div className="p-4 bg-white rounded-xl shadow-sm border">
                <h4 className="font-semibold mb-3 text-main-600">
                  Business Information
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                  <p>
                    <b>Business Name:</b> {formData.businessName}
                  </p>
                  <p>
                    <b>Business Type:</b> {formData.businessType}
                  </p>
                  <p>
                    <b>Business ID:</b> {formData.businessNumber}
                  </p>
                  <p>
                    <b>PAN:</b> {formData.panNumber}
                  </p>
                  <p>
                    <b>GST:</b> {formData.gstNumber || "Not Provided"}
                  </p>
                </div>
              </div>

              {/* ADDRESS */}
              <div className="p-4 bg-white rounded-xl shadow-sm border">
                <h4 className="font-semibold mb-3 text-main-600">
                  Address Details
                </h4>
                <div className="text-sm space-y-2">
                  <p>
                    <b>Shop Address:</b> {formData.shopAddress}
                  </p>
                  <p>
                    <b>City:</b> {formData.city}
                  </p>
                  <p>
                    <b>State:</b> {formData.state}
                  </p>
                  <p>
                    <b>Pincode:</b> {formData.pincode}
                  </p>
                </div>
              </div>

              {/* BANK */}
              <div className="p-4 bg-white rounded-xl shadow-sm border">
                <h4 className="font-semibold mb-3 text-main-600">
                  Bank Information
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                  <p>
                    <b>Account Holder:</b> {formData.accountHolder}
                  </p>
                  <p>
                    <b>Account Number:</b> {formData.accountNumber}
                  </p>
                  <p>
                    <b>IFSC:</b> {formData.ifsc}
                  </p>
                  <p>
                    <b>Bank Name:</b> {formData.bankName}
                  </p>
                </div>
              </div>

              {/* DOCUMENTS */}
              <div className="p-4 bg-white rounded-xl shadow-sm border">
                <h4 className="font-semibold mb-3 text-main-600">
                  Uploaded Documents
                </h4>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                  {preview.panCard && (
                    <div className="text-center">
                      <p className="text-xs font-semibold mb-2">PAN Card</p>
                      <img
                        src={preview.panCard}
                        className="w-full h-28 object-cover border rounded"
                      />
                    </div>
                  )}

                  {preview.gstCertificate && (
                    <div className="text-center">
                      <p className="text-xs font-semibold mb-2">
                        GST Certificate
                      </p>
                      <img
                        src={preview.gstCertificate}
                        className="w-full h-28 object-cover border rounded"
                      />
                    </div>
                  )}

                  {preview.addressProof && (
                    <div className="text-center">
                      <p className="text-xs font-semibold mb-2">
                        Address Proof
                      </p>
                      <img
                        src={preview.addressProof}
                        className="w-full h-28 object-cover border rounded"
                      />
                    </div>
                  )}

                  {preview.cancelledCheque && (
                    <div className="text-center">
                      <p className="text-xs font-semibold mb-2">
                        Cancelled Cheque
                      </p>
                      <img
                        src={preview.cancelledCheque}
                        className="w-full h-28 object-cover border rounded"
                      />
                    </div>
                  )}

                  {preview.businessproof && (
                    <div className="text-center">
                      <p className="text-xs font-semibold mb-2">
                        Business Proof
                      </p>
                      <img
                        src={preview.businessproof}
                        className="w-full h-28 object-cover border rounded"
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* <p className="text-gray-500 text-sm text-center pt-4">
              If anything looks wrong, press Back and edit before submitting.
            </p> */}
            </div>
          </div>
        </>
      );
    }

    switch (step) {
      case 1:
        return (
          <div className="space-y-6">
            <div className="flex items-center gap-3 mb-4">
              <User size={20} className="text-main-600" />
              <h2 className="text-xl fw-semibold">Personal Information</h2>
            </div>

            <div>
              <label className={labelClass}>
                Full Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                style={highlight("fullName")}
                onChange={handleChange}
                className={inputClass}
              />
            </div>

            <div>
              <label className={labelClass}>
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                style={highlight("email")}
                onChange={handleChange}
                className={inputClass}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className={labelClass}>
                  Phone <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  style={highlight("phone")}
                  onChange={handleChange}
                  className={inputClass}
                  maxLength="13"
                />
              </div>

              <div>
                <label className={labelClass}>
                  DOB <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  name="dob"
                  value={formData.dob}
                  style={highlight("dob")}
                  onChange={handleChange}
                  className={inputClass}
                />
              </div>
            </div>
          </div>
        );

      case 2:
        return (
          <div className="space-y-6">
            <div className="flex items-center gap-3 mb-4">
              <Store size={20} className="text-main-600" />
              <h2 className="text-xl fw-semibold">Business Info</h2>
            </div>

            <div>
              <label className={labelClass}>
                Business Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="businessName"
                value={formData.businessName}
                style={highlight("businessName")}
                onChange={handleChange}
                className={inputClass}
              />
            </div>

            <div>
              <label className={labelClass}>
                Business Type <span className="text-danger">*</span>
              </label>
              <select
                name="businessType"
                value={formData.businessType}
                style={highlight("businessType")}
                onChange={handleChange}
                className={inputClass}
              >
                <option value="">-- Select Type --</option>
                <option value="proprietorship">Sole Proprietorship</option>
                <option value="partnership">Partnership</option>
                <option value="pvt_ltd">Private Limited</option>
                <option value="llp">LLP</option>
                <option value="individual">Individual</option>
              </select>
            </div>

            <div>
              <label className={labelClass}>
                Business Identification Number
              </label>
              <input
                type="text"
                name="businessNumber"
                value={formData.businessNumber}
                style={highlight("businessNumber")}
                onChange={handleChange}
                className={inputClass}
                placeholder="Eg. CIN/UDYAM/etc."
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className={labelClass}>GST (Optional)</label>
                <input
                  type="text"
                  name="gstNumber"
                  value={formData.gstNumber}
                  style={highlight("gstNumber")}
                  onChange={handleChange}
                  className={inputClass}
                  maxLength="15"
                />
              </div>

              <div>
                <label className={labelClass}>
                  PAN <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="panNumber"
                  value={formData.panNumber}
                  style={highlight("panNumber")}
                  onChange={handleChange}
                  className={inputClass}
                  maxLength="10"
                />
              </div>
            </div>
          </div>
        );

      case 3:
        return (
          <div className="space-y-6">
            <div className="flex items-center gap-3 mb-4">
              <MapPin size={20} className="text-main-600" />
              <h2 className="text-xl fw-semibold">Address Details</h2>
            </div>

            <div>
              <label className={labelClass}>
                Shop Address <span className="text-danger">*</span>
              </label>
              <textarea
                name="shopAddress"
                value={formData.shopAddress}
                style={highlight("shopAddress")}
                onChange={handleChange}
                className="common-input w-full min-h-[100px]"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className={labelClass}>
                  City <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  style={highlight("city")}
                  onChange={handleChange}
                  className={inputClass}
                />
              </div>

              <div>
                <label className={labelClass}>
                  State <span className="text-danger">*</span>
                </label>
                <select
                  name="state"
                  value={formData.state}
                  style={highlight("state")}
                  onChange={handleChange}
                  className={inputClass}
                >
                  <option value="">Select State</option>
                  <option value="MH">Maharashtra</option>
                  <option value="MP">Madhya Pradesh</option>
                  <option value="RJ">Rajasthan</option>
                  <option value="GJ">Gujarat</option>
                  <option value="DL">Delhi</option>
                  <option value="UP">Uttar Pradesh</option>
                </select>
              </div>
            </div>

            <div>
              <label className={labelClass}>
                PIN Code <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="pincode"
                value={formData.pincode}
                style={highlight("pincode")}
                onChange={handleChange}
                className={inputClass}
                maxLength="6"
              />
            </div>
          </div>
        );

      case 4:
        return (
          <div className="space-y-6">
            <div className="flex items-center gap-3 mb-4">
              <FileText size={20} className="text-main-600" />
              <h2 className="text-xl fw-semibold">Bank Details</h2>
            </div>

            <div>
              <label className={labelClass}>
                Account Holder <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="accountHolder"
                value={formData.accountHolder}
                style={highlight("accountHolder")}
                onChange={handleChange}
                className={inputClass}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className={labelClass}>
                  Account Number <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="accountNumber"
                  value={formData.accountNumber}
                  style={highlight("accountNumber")}
                  onChange={handleChange}
                  className={inputClass}
                  maxLength="18"
                />
              </div>

              <div>
                <label className={labelClass}>
                  IFSC <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="ifsc"
                  value={formData.ifsc}
                  style={highlight("ifsc")}
                  onChange={handleChange}
                  className={inputClass}
                  maxLength="11"
                />
              </div>
            </div>

            <div>
              <label className={labelClass}>
                Bank Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="bankName"
                value={formData.bankName}
                style={highlight("bankName")}
                onChange={handleChange}
                className={inputClass}
              />
            </div>
          </div>
        );

      case 5:
        return (
          <div className="space-y-6">
            <div className="flex items-center gap-3 mb-4">
              <Upload size={20} className="text-main-600" />
              <h2 className="text-xl fw-semibold">Documents</h2>
            </div>

            {/* PAN */}
            <div>
              <label className={labelClass}>PAN Card</label>
              {preview.panCard && (
                <img
                  src={preview.panCard}
                  className="w-full max-w-[160px] h-24 object-cover rounded mb-3 border"
                />
              )}
              <input
                type="file"
                name="panCard"
                onChange={handleFileChange}
                className={inputClass}
              />
            </div>

            {/* GST */}
            <div>
              <label className={labelClass}>GST Certificate</label>
              {preview.gstCertificate && (
                <img
                  src={preview.gstCertificate}
                  className="w-full max-w-[160px] h-24 object-cover rounded mb-3 border"
                />
              )}
              <input
                type="file"
                name="gstCertificate"
                onChange={handleFileChange}
                className={inputClass}
              />
            </div>

            {/* Address Proof */}
            <div>
              <label className={labelClass}>Address Proof</label>
              {preview.addressProof && (
                <img
                  src={preview.addressProof}
                  className="w-full max-w-[160px] h-24 object-cover rounded mb-3 border"
                />
              )}
              <input
                type="file"
                name="addressProof"
                onChange={handleFileChange}
                className={inputClass}
              />
            </div>

            {/* Cancelled Cheque */}
            <div>
              <label className={labelClass}>Cancelled Cheque</label>
              {preview.cancelledCheque && (
                <img
                  src={preview.cancelledCheque}
                  className="w-full max-w-[160px] h-24 object-cover rounded mb-3 border"
                />
              )}
              <input
                type="file"
                name="cancelledCheque"
                onChange={handleFileChange}
                className={inputClass}
              />
            </div>

            {/**business proof*/}
            <div>
              <label className={labelClass}>Business Proof</label>
              {preview.businessproof && (
                <img
                  src={preview.businessproof}
                  className="w-full max-w-[160px] h-24 object-cover rounded mb-3 border"
                />
              )}
              <input
                type="file"
                name="businessproof"
                onChange={handleFileChange}
                className={inputClass}
              />
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <ColorInit color={true} />
      {/* <ScrollToTop smooth color="#1E293B" /> */}
      <Preloader />
      <HeaderOne category={true} />
      <Breadcrumb title={"Become Seller"} />

      <section className="account py-80">
        <div className="container container-lg">
          <div className="row justify-center">
            <div className="col-xl-8">
              <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-16 bg-white shadow-sm">
                {isSuccess ? (
                  <div className="text-center py-20">
                    <CheckCircle
                      size={64}
                      className="mx-auto text-success-500 mb-6"
                    />
                    <h2 className="text-3xl fw-semibold mb-3">Thank You!</h2>
                    <p className="text-gray-600 mb-8">
                      Your seller application has been submitted.
                      <br />
                      We will contact you soon.
                    </p>
                  </div>
                ) : (
                  <>
                    <div className="text-center mb-6">
                      <h4 className="text-2xl fw-semibold mb-8">
                        Become a Seller
                      </h4>
                      <p className="text-gray-600 text-sm mb-40">
                        Fill all details below.
                      </p>
                    </div>

                    <StepIndicator />

                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        nextStep();
                      }}
                    >
                      <div className="mb-6">{renderStep()}</div>

                     {isReview && (
                      <>
                       <label className="flex items-start gap-3 text-sm text-gray-700 cursor-pointer mt-12">
                        <input
                          type="checkbox"
                          checked={agree}
                          onChange={(e) => setAgree(e.target.checked)}
                          className="mt-1 accent-main-600 scale-125 sm:scale-150"
                        />
                        <span className="leading-relaxed">
                          I agree to the{" "}
                          <a
                            href="/vendor-policy"
                            target="_blank"
                            className="text-main-600 underline"
                          >
                            Vendor Policy
                          </a>
                          ,{" "}
                          <a
                            href="/terms-of-use"
                            target="_blank"
                            className="text-main-600 underline"
                          >
                            Terms of Use
                          </a>
                          ,{" "}
                          <a
                            href="/privacy-policy"
                            target="_blank"
                            className="text-main-600 underline"
                          >
                            Privacy Policy
                          </a>
                          ,{" "}
                          <a
                            href="/refund-policy"
                            target="_blank"
                            className="text-main-600 underline"
                          >
                            Refund Policy
                          </a>{" "}
                          and{" "}
                          <a
                            href="/shipping-policy"
                            target="_blank"
                            className="text-main-600 underline"
                          >
                            Shipping Policy
                          </a>
                          .
                        </span>
                      </label>
                      </>
                     )}

                      <div className="flex items-center justify-between mt-24">
                        {step > 1 && (
                          <button
                            type="button"
                            onClick={prevStep}
                            className="btn btn-main py-12 px-24"
                          >
                            <ChevronLeft />
                          </button>
                        )}

                        <div className="ml-auto flex items-center gap-3">
                          {step < totalSteps && !isReview && (
                            <button
                              type="submit"
                              className="btn btn-main py-12 px-24"
                            >
                              <ChevronRight />
                            </button>
                          )}

                          {step === totalSteps && !isReview && (
                            <button
                              type="submit"
                              className="btn btn-main py-12 px-24"
                            >
                              <ChevronRight />
                            </button>
                          )}

                          {isReview && (
                            <button
                              type="submit"
                              className="btn btn-main py-12 px-24"
                            >
                              <CheckCircle />
                            </button>
                          )}
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterOne />
      {/* <BottomFooter /> */}
    </>
  );
};

export default SellerForm;
